(() => {
  const firstKey = 'eb_first_touch';
  const lastKey = 'eb_last_touch';
  const pendingKey = 'eb_pending_lead_event';
  const pendingFallbackKey = 'eb_pending_lead_event_fallback';
  const adsConsentCookieKey = 'eb_ads_submit_allowed';
  const pendingTtlMs = 30 * 60 * 1000;
  const googleAdsId = 'AW-18324800520';
  const googleAdsSendTo = `${googleAdsId}/kFN7CMri6NgcEIiI-aFE`;
  const googleTagSrc = `https://www.googletagmanager.com/gtag/js?id=${googleAdsId}`;
  const googleTagInitializedKey = '__ebGoogleAdsTagInitialized';
  const submitRecoveryMs = 30000;
  const submittingTimers = new WeakMap();
  const params = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'wbraid', 'gbraid', 'fbclid'];
  const query = new URLSearchParams(window.location.search);
  const touch = {
    landing_page: window.location.href,
    referrer: document.referrer || '',
    captured_at: new Date().toISOString(),
  };
  params.forEach((key) => { touch[key] = query.get(key) || ''; });

  const privacyApi = () => window.Shopify && window.Shopify.customerPrivacy;
  const analyticsAllowed = () => {
    const api = privacyApi();
    return api ? api.analyticsProcessingAllowed() : !window.Shopify;
  };
  const marketingAllowed = () => {
    const api = privacyApi();
    return api ? api.marketingAllowed() : !window.Shopify;
  };
  const read = (key) => {
    if (!marketingAllowed()) return null;
    try { return JSON.parse(window.localStorage.getItem(key) || 'null'); } catch (_) { return null; }
  };
  const write = (key, value) => {
    if (!marketingAllowed()) return;
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };
  const clearTouch = () => {
    try {
      window.localStorage.removeItem(firstKey);
      window.localStorage.removeItem(lastKey);
    } catch (_) {}
  };
  const removeStored = (storage, key) => {
    try { storage.removeItem(key); } catch (_) {}
  };
  const clearAdsConsentCookie = () => {
    try {
      document.cookie = `${adsConsentCookieKey}=; Max-Age=0; Path=/; SameSite=Lax; Secure`;
    } catch (_) {}
  };
  const syncAdsConsentCookie = () => {
    if (!analyticsAllowed() || !marketingAllowed()) {
      clearAdsConsentCookie();
      return;
    }
    try {
      document.cookie = `${adsConsentCookieKey}=1; Max-Age=${pendingTtlMs / 1000}; Path=/; SameSite=Lax; Secure`;
    } catch (_) {}
  };
  const consumeAdsConsentCookie = () => {
    let allowed = false;
    try {
      allowed = (`; ${document.cookie || ''}`).includes(`; ${adsConsentCookieKey}=1`);
    } catch (_) {}
    clearAdsConsentCookie();
    return allowed;
  };
  const parseStoredPending = (raw) => {
    if (!raw) return null;
    let record = null;
    try { record = JSON.parse(raw); } catch (_) { return null; }
    if (!record || record.version !== 1 || !record.detail) return null;
    const savedAt = Number(record.saved_at || 0);
    if (!savedAt || Date.now() - savedAt > pendingTtlMs) return null;
    return record;
  };
  const scheduleStoredRemoval = (storage, key, savedAt) => {
    if (typeof window.setTimeout !== 'function') return;
    const remaining = Math.max(0, pendingTtlMs - (Date.now() - savedAt));
    window.setTimeout(() => {
      let current = null;
      try { current = JSON.parse(storage.getItem(key) || 'null'); } catch (_) {}
      if (!current || Number(current.saved_at || 0) === savedAt) removeStored(storage, key);
    }, remaining + 1000);
  };
  const cleanupStoredPending = (storage, key) => {
    let raw = null;
    try { raw = storage.getItem(key); } catch (_) { return; }
    if (!raw) return;
    const record = parseStoredPending(raw);
    if (!record) {
      removeStored(storage, key);
      return;
    }
    scheduleStoredRemoval(storage, key, Number(record.saved_at));
  };
  const consumeStoredPending = (storage, key) => {
    let raw = null;
    try { raw = storage.getItem(key); } catch (_) {}
    removeStored(storage, key);
    return parseStoredPending(raw);
  };
  const cleanupPending = () => {
    const api = privacyApi();
    if (window.Shopify && !api) return;
    if (analyticsAllowed()) cleanupStoredPending(window.sessionStorage, pendingKey);
    else removeStored(window.sessionStorage, pendingKey);
    if (marketingAllowed()) cleanupStoredPending(window.localStorage, pendingFallbackKey);
    else {
      removeStored(window.localStorage, pendingFallbackKey);
      clearAdsConsentCookie();
    }
  };
  const savePending = (detail) => {
    if (!analyticsAllowed()) {
      removeStored(window.sessionStorage, pendingKey);
      removeStored(window.localStorage, pendingFallbackKey);
      clearAdsConsentCookie();
      return;
    }
    const adsAllowed = marketingAllowed();
    const savedAt = Date.now();
    const record = {
      version: 1,
      saved_at: savedAt,
      ads_allowed: adsAllowed,
      detail: {
        lead_type: detail.lead_type || 'quote',
        source_page: detail.source_page || '',
      },
    };
    try { window.sessionStorage.setItem(pendingKey, JSON.stringify(record)); } catch (_) {}
    scheduleStoredRemoval(window.sessionStorage, pendingKey, savedAt);
    if (!adsAllowed) {
      removeStored(window.localStorage, pendingFallbackKey);
      clearAdsConsentCookie();
      return;
    }
    try { window.localStorage.setItem(pendingFallbackKey, JSON.stringify(record)); } catch (_) {}
    scheduleStoredRemoval(window.localStorage, pendingFallbackKey, savedAt);
  };
  const consumePending = () => {
    const sessionRecord = consumeStoredPending(window.sessionStorage, pendingKey);
    if (!marketingAllowed()) {
      removeStored(window.localStorage, pendingFallbackKey);
      return sessionRecord;
    }
    const fallbackRecord = consumeStoredPending(window.localStorage, pendingFallbackKey);
    return sessionRecord || fallbackRecord;
  };
  const clearProcessedSuccessMarker = () => {
    if (!window.history || typeof window.history.replaceState !== 'function') return;
    try {
      const cleaned = new URL(window.location.href);
      cleaned.searchParams.delete('contact_posted');
      window.history.replaceState(window.history.state, '', `${cleaned.pathname}${cleaned.search}${cleaned.hash}`);
    } catch (_) {}
  };
  const captureTouch = () => {
    if (!marketingAllowed()) {
      clearTouch();
      return;
    }
    const hasCampaign = params.some((key) => query.get(key));
    if (!read(firstKey)) write(firstKey, touch);
    if (hasCampaign || !read(lastKey)) write(lastKey, touch);
  };
  const publish = (event, detail = {}) => {
    if (!analyticsAllowed()) return;
    const payload = { lead_event: event, ...detail };
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        Promise.resolve(window.Shopify.analytics.publish(`entropy_bright:${event}`, payload)).catch(() => {});
      } catch (_) {}
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: `entropy_bright:${event}`, ...payload });
    }
    document.dispatchEvent(new CustomEvent(`eb:${event}`, { detail: payload }));
  };
  const ensureGoogleAdsTag = () => {
    window.dataLayer = window.dataLayer || [];
    const hasGtag = typeof window.gtag === 'function';
    const existingScript = document.querySelector(
      `script[src*="googletagmanager.com/gtag/js"][src*="${googleAdsId}"]`,
    );
    if (!hasGtag && !existingScript) {
      const script = document.createElement('script');
      script.async = true;
      script.src = googleTagSrc;
      script.dataset.ebGoogleAdsTag = 'true';
      (document.head || document.documentElement).appendChild(script);
    }
    if (!hasGtag) {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    if (!window[googleTagInitializedKey]) {
      window[googleTagInitializedKey] = true;
      window.gtag('js', new Date());
      window.gtag('config', googleAdsId, { send_page_view: false });
    }
  };
  const sendGoogleAdsLeadConversion = () => {
    if (!marketingAllowed()) return;
    ensureGoogleAdsTag();
    window.gtag('event', 'conversion', {
      send_to: googleAdsSendTo,
    });
  };
  const addHidden = (form, name, value) => {
    let field = form.querySelector(`[name="${name}"]`);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      field.dataset.ebAttribution = 'true';
      form.appendChild(field);
    }
    field.value = value || '';
  };
  const typeForSource = (source) => {
    const value = (source || '').toLowerCase();
    if (value.includes('sample')) return 'sample';
    if (value.includes('trade')) return 'trade';
    if (value.includes('catalog')) return 'catalog';
    if (value.includes('custom')) return 'custom';
    return 'quote';
  };
  const enrich = (form) => {
    const sourceField = form.querySelector('[name="contact[Source page]"]');
    if (!sourceField) return null;
    if (!marketingAllowed()) {
      form.querySelectorAll('[data-eb-attribution="true"]').forEach((field) => field.remove());
      return sourceField.value;
    }
    const first = read(firstKey) || touch;
    const last = read(lastKey) || touch;
    const fields = {
      'contact[First touch UTM source]': first.utm_source,
      'contact[First touch UTM medium]': first.utm_medium,
      'contact[First touch UTM campaign]': first.utm_campaign,
      'contact[Last touch UTM source]': last.utm_source,
      'contact[Last touch UTM medium]': last.utm_medium,
      'contact[Last touch UTM campaign]': last.utm_campaign,
      'contact[Landing page]': first.landing_page,
      'contact[Latest page]': window.location.href,
      'contact[Initial referrer]': first.referrer,
      'contact[gclid]': last.gclid || first.gclid,
      'contact[wbraid]': last.wbraid || first.wbraid,
      'contact[gbraid]': last.gbraid || first.gbraid,
    };
    Object.entries(fields).forEach(([name, value]) => addHidden(form, name, value));
    return sourceField.value;
  };
  const resetFormSubmitting = (form) => {
    const timer = submittingTimers.get(form);
    if (timer) window.clearTimeout(timer);
    submittingTimers.delete(form);
    delete form.dataset.ebSubmitting;
    const button = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!button) return;
    button.disabled = false;
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    const original = button.dataset.originalText;
    if (!original) return;
    if (button.tagName === 'BUTTON') button.textContent = original;
    else button.value = original;
  };
  const resetSubmitting = () => {
    document.querySelectorAll('form[data-eb-submitting="true"]').forEach(resetFormSubmitting);
  };
  const bind = () => {
    document.querySelectorAll('form').forEach((form) => {
      const source = enrich(form);
      if (!source) return;
      syncAdsConsentCookie();
      if (form.dataset.ebLeadBound === 'true') return;
      form.dataset.ebLeadBound = 'true';
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) return;
        if (form.dataset.ebSubmitting === 'true') {
          return;
        }
        form.dataset.ebSubmitting = 'true';
        submittingTimers.set(form, window.setTimeout(() => resetFormSubmitting(form), submitRecoveryMs));
        const leadType = typeForSource(source);
        const detail = { lead_type: leadType, source_page: source, page_location: window.location.href };
        publish('lead_submit_attempt', detail);
        savePending(detail);
        const button = form.querySelector('button[type="submit"], input[type="submit"]');
        if (button) {
          button.dataset.originalText = button.tagName === 'BUTTON' ? button.textContent : button.value;
          button.disabled = true;
          button.classList.add('is-loading');
          button.setAttribute('aria-busy', 'true');
          if (button.tagName === 'BUTTON') button.textContent = button.dataset.loadingText || 'Sending…';
          else button.value = button.dataset.loadingText || 'Sending…';
        }
      });
    });
    document.querySelectorAll('a[href*="wa.me/"]').forEach((link) => {
      if (link.dataset.ebWhatsappBound === 'true') return;
      link.dataset.ebWhatsappBound = 'true';
      link.addEventListener('click', () => publish('whatsapp_click', { page_location: window.location.href }));
    });
    const posted = new URLSearchParams(window.location.search).get('contact_posted') === 'true';
    if (posted && analyticsAllowed()) {
      const pending = consumePending();
      const currentPath = window.location.pathname
        || window.location.href.replace(/^https?:\/\/[^/]+/, '').split(/[?#]/)[0];
      const quoteSuccess = /\/pages\/request-a-quote\/?$/.test(currentPath);
      const cookieAllowed = consumeAdsConsentCookie();
      const detail = pending ? pending.detail : (quoteSuccess && cookieAllowed ? {
        lead_type: 'quote',
        source_page: 'request-a-quote',
      } : null);
      if (detail) {
        publish('lead_confirmed', detail);
        const adsAllowed = pending ? pending.ads_allowed === true : cookieAllowed;
        if (adsAllowed) sendGoogleAdsLeadConversion();
        clearProcessedSuccessMarker();
      }
    }
  };
  const start = () => {
    cleanupPending();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
    else bind();
  };

  document.addEventListener('visitorConsentCollected', () => {
    cleanupPending();
    captureTouch();
    bind();
  });
  window.addEventListener('pageshow', resetSubmitting);

  start();
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
      cleanupPending();
      captureTouch();
      bind();
    });
  } else {
    captureTouch();
  }
})();
